import React, { Component } from 'react';
//import { render } from 'react-dom'
import { Form, Radio } from 'semantic-ui-react'
import { log } from '../../Utilities/Utils'
import { ref } from '../../config/constants.js'
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import ConfirmOrder from './ConfirmOrder'
import * as OrderForm from './orderFormComponents/OrderFormParts'
import MainMenu from '../Menus/MainMenu'

// import createBrowserHistory from 'history/createBrowserHistory';
// const history = createBrowserHistory({forceRefresh:false});

//import { Router, Route, Switch } from 'react-router'


export default class NewOrderForm extends Component {
    constructor(props) {
        super(props);
        console.log("+++++: NewOrderForm constructor");
        this.state = {
            totalPrice: 0,
            deliverCharge: 0,
            email: this.props.user.email,
            phone: this.props.user.phone,
            numPages: '',
            numCopies: '',
            location: '',
            blackWhiteColor: 'black',
            printPhotocopy: 'print',
            looseStapled: 'loose',
            paperSize: 'A4',
            singleDoubleSided: 'single',
            binding: 'none',
            isUploading: false,
            progress: 0,
            fileName: '',
            fileUrl: 'none',
            pageCostTest: 0,
            //-------: PRICING STUFF
            pageColorCost: 300,
            totalNumpages: 0,
            printOrPhotoCopyMultiplier: 1,
            stapleCost: 0,
            paperSizeMultiplier: 1,
            bindingCharge: 0,
            //-- transport
            confirmOrder: false,
            newOrderObjectToConfirm: '',
            //-- validation
            formErrors: { email: '', phone: '' },
            emailValid: false,
            phoneValid: false,
            locationValid: false,
            formHasErrors: false,
            allFieldsValid: null,
            locationValid: false,
            numPagesValid: false,
            numCopiesValid: false,
            firstLoaded: true
        }

        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.saveOrder = this.saveOrder.bind(this);

        // this.updateTotalCost = this.updateTotalCost.bind(this);
        this.calculateTotal = this.calculateTotal.bind(this);
        this.testHandleInputFromComponent = this.testHandleInputFromComponent.bind(this);
        this.updateOrderObject = this.updateOrderObject.bind(this);
    }

    updateOrderObject() {
        // console.log("xx1 ++++++++:updateOrderObject");
        var d = new Date();
        var n = d.toString();

        let newOrderObject = {
            totalPrice: this.state.totalPrice,
            userEmail: this.state.email,
            userPhone: this.state.phone,
            numPages: this.state.numPages,
            numCopies: this.state.numCopies,
            totalNumpages: this.state.totalNumpages,
            blackWhiteColor: this.state.blackWhiteColor,
            dateString: n,
            dateNum: d.getTime(),
            printPhotocopy: this.state.printPhotocopy,
            looseStapled: this.state.looseStapled,
            paperSize: this.state.paperSize,
            singleDoubleSided: this.state.singleDoubleSided,
            binding: this.state.binding,
            fileName: this.state.fileName,
            status: 'unconfirmed',
            emailsSent: false
        }

        //log("updateOrderObject:"+);
        this.setState({
            newOrderObjectToConfirm: newOrderObject
        });
    }

    /**
     * SEND TO SERVER
     */
    handleSubmit = (e, message) => {
        e.preventDefault();
        console.log("hx15 >>>>: handleSubmit clicked");

        var d = new Date();
        var n = d.toString();

        let newOrderObject = {
            totalPrice: this.state.totalPrice,
            userEmail: this.state.email,
            userPhone: this.state.phone,
            numPages: this.state.numPages,
            numCopies: this.state.numCopies,
            totalNumpages: this.state.totalNumpages,
            blackWhiteColor: this.state.blackWhiteColor,
            dateString: n,
            dateNum: d.getTime(),
            printPhotocopy: this.state.printPhotocopy,
            looseStapled: this.state.looseStapled,
            paperSize: this.state.paperSize,
            singleDoubleSided: this.state.singleDoubleSided,
            binding: this.state.binding,
            fileName: this.state.fileName,
            status: 'unconfirmed',
            emailsSent: false
        }

        this.setState({
            newOrderObjectToConfirm: newOrderObject
        });


        this.saveOrder(newOrderObject);

        console.log("hx16 formObject:" + newOrderObject);
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState, () => { this.validateField(name, value) });

        // this.setState({[name]: value}, 
        //     () => { this.validateField(name, value) });

        let totalNumpages = 0;

        /**
         * GET NUMBER OF PAGES
         */
        if (e.target.name === 'numPages') {
            //console.log("hx35 its numPages:" + e.target.value);
            // console.log("hx36 their state numPages:" + this.state.numPages);

            totalNumpages = e.target.value * this.state.numCopies;
            // console.log("hx37 their internal totalNumpages:" + totalNumpages);

            this.setState({ totalNumpages: totalNumpages });
            //console.log("hx38  state totalNumpages:" + this.state.totalNumpages);

            let newTotal = totalNumpages * (this.state.pageColorCost * this.state.printOrPhotoCopyMultiplier) + this.state.stapleCost + this.state.bindingCharge;;
            this.setState({ totalPrice: newTotal });
            console.log("hx391 newTotal:" + newTotal);

            //UPDATE OBJECT
            this.updateOrderObject();

            /**
             * GET NUM OF COPIES
             */
        } else if (e.target.name === 'numCopies') {
            // console.log("hx39 its numCopies:" + e.target.value);
            // console.log("hx40 their state numCopies:" + this.state.numCopies);

            totalNumpages = e.target.value * this.state.numPages;
            // console.log("hx41 their internal totalNumpages:" + totalNumpages);

            this.setState({ totalNumpages: totalNumpages });
            //console.log("hx38  state totalNumpages:" + this.state.totalNumpages);

            let newTotal = totalNumpages * (this.state.pageColorCost * this.state.printOrPhotoCopyMultiplier) + this.state.stapleCost + this.state.bindingCharge;;
            this.setState({ totalPrice: newTotal });
            console.log("hx391 newTotal:" + newTotal);

            //UPDATE OBJECT
            this.updateOrderObject();
        }else{
            console.log("hx401 field is not num copies or num pages..");
        }

        // console.log("hx390 totalNumpages:" + totalNumpages);
        // console.log("hx391 pageColorCost:" + this.state.pageColorCost);
        // console.log("hx392 printOrPhotoCopyMultiplier:" + this.state.printOrPhotoCopyMultiplier);
        // console.log("hx393 stapleCost:" + this.state.stapleCost);
        // console.log("hx394 bindingCharge:" + this.state.bindingCharge);



        //console.log("hx14 this.state.numPages:"+this.state.numPages);
        //console.log("hx14 this.state.numCopies:"+this.state.numCopies);
        // let totalNumpagesTemp = 0;
        // totalNumpagesTemp = this.state.numPages * this.state.numCopies;
        //console.log("hx14 totalNumpagesTemp:"+totalNumpagesTemp);
    };

    validateField = (fieldName, value) => {
        console.log("vx1 ++++++++: validate field");
        console.log("vx12 fieldName:" + fieldName);
        console.log("vx13 value:" + value);

        let fieldValidationErrors = this.state.formErrors;
        let emailValid = this.state.emailValid;
        let phoneValid = this.state.phoneValid;
        let locationValid = this.state.locationValid;
        let numPagesValid = this.state.numPagesValid;
        let numCopiesValid = this.state.numCopiesValid;

        switch (fieldName) {
            case 'email':
                console.log("vx14 fieldName is EMAIL");
                emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.email = emailValid ? '' : ' is invalid, enter a valid email address';
                // console.log("vx141 is email valid:"+emailValid);
                // console.log("vx1411 fieldValidationErrors:"+fieldValidationErrors.email);
                break;
            case 'phone':
                console.log("vx15 fieldName is PHONE");
                //phoneValid = value.length >= 10;
                phoneValid = value.match(/^0\d{9}$/);
                fieldValidationErrors.phone = phoneValid ? '' : ' is invalid. Ex. 0790431987';
                // console.log("vx1421 is email valid:"+phoneValid);
                // console.log("vx14211 fieldValidationErrors:"+fieldValidationErrors.phone);
                // console.log("vx142 is phone valid:"+phoneValid);
                break;
            case 'location':
                console.log("vx151 fieldName is location");
                //phoneValid = value.length >= 10;
                locationValid = value.length >= 10 ? true : false;
                fieldValidationErrors.location = locationValid ? '' : ' is too short';
                // console.log("vx1421 is email valid:"+phoneValid);
                // console.log("vx14211 fieldValidationErrors:"+fieldValidationErrors.phone);
                // console.log("vx142 is phone valid:"+phoneValid);
                break;
            case 'numPages':
                console.log("vx152 fieldName is numPages");
                //phoneValid = value.length >= 10;
                numPagesValid = isNaN(value) ? false : true;
                fieldValidationErrors.numPages = numPagesValid ? '' : ' invalid number of Pages';
                console.log("vx1521 is numPagesValid:" + numPagesValid);
                break;
            case 'numCopies':
                console.log("vx153 fieldName is numCopies");
                numCopiesValid = isNaN(value) ? false : true;
                fieldValidationErrors.numCopies = numCopiesValid ? '' : ' invalid number of Copies';
                console.log("vx1531 is numCopiesValid:" + numCopiesValid);
                break;
            default:
                break;
        }

        // console.log("px1 emailValid:"+emailValid);
        // console.log("px12 phoneValid:"+phoneValid);

        let tempFormHasErrors = emailValid === undefined && phoneValid === undefined;
        console.log("vx142 tempFormValid:" + tempFormHasErrors);

        // let checkEmialPhone = ((emailValid !== null && ) && phoneValid !== null);
        let allFieldsValid = (emailValid && this.state.email && phoneValid && this.state.phone && locationValid && numCopiesValid && numPagesValid) ? true : false;
        console.log("vx77 emailValid:" + emailValid);
        console.log("vx771 phoneValid:" + phoneValid);
        console.log("vx772 locationValid:" + locationValid);
        console.log("vx773 numCopiesValid:" + numCopiesValid);
        console.log("vx774 numPagesValid:" + numPagesValid);
        console.log("vx775 allFieldsValid:" + allFieldsValid);

        console.log("vx776 this.state.email :" + this.state.email);
        console.log("vx777 this.state.phone :" + this.state.phone);

        this.setState({
            formErrors: fieldValidationErrors,
            emailValid: emailValid,
            phoneValid: phoneValid,
            formHasErrors: tempFormHasErrors,
            locationValid: locationValid,
            numCopiesValid: numCopiesValid,
            numPagesValid: numPagesValid,
            allFieldsValid: allFieldsValid,
            firstLoaded: false
        }, this.validateForm);

        console.log("+++++++++  XX  +++++++++++");
    }

    componentDidMount() {
        // console.log("cx1 +++++++ componentDidMount");

        this.checkInitialFields();
    }

    /**
     * CHECK FIELDS THAT ARE AUTO FILLED IN.. EMAIL PHONE
     */
    checkInitialFields = () => {
        // console.log("cx2 ++++++++ checkInitialFields");
        // console.log("cx21 this.state.email :" + this.state.email);
        // console.log("cx22 this.state.phone :" + this.state.phone);

        let initEmail = false;
        let initPhone = false;

        let fieldValidationErrors = this.state.formErrors;

        //CHECK email
        if (this.state.email != null) {
            console.log("cx23 email is not null:" + this.state.email);
            initEmail = true;
        } else {
            console.log("cx231 email is null:");
        }

        //CHECK phone
        if (this.state.phone != null) {
            console.log("cx24 phone is not null:" + this.state.phone);
            initPhone = this.state.phone.match(/^0\d{9}$/);

            if (initPhone === null) {
                console.log("initPhone === null");
                fieldValidationErrors.phone = ' is invalid. Ex. 0790431987';
            } else {
                console.log("initPhone is NOT null)")
            }

        } else {
            console.log("cx241 phone is  null:" + this.state.phone);
        }

        this.setState({
            emailValid: initEmail,
            phoneValid: initPhone,
            formErrors: fieldValidationErrors,
        })

    }

    validateForm = () => {

        // this.setState({ formValid: this.state.emailValid !== undefined && this.state.phoneValid != undefined});
    }

    calculateTotal() {
        // console.log("calc shit..");
        // console.log("calc shit.:totalNumpages:" + this.state.totalNumpages);
        // console.log("calc shit.:pageColorCost:" + this.state.pageColorCost);
        let newTotal = this.state.totalNumpages * this.state.pageColorCost;
        // console.log("calc shit newTotal:" + newTotal);
    }

    saveOrder = data => ref.child('orders').push(data, response => response);

    // saveOrder(newOrder){
    //     ref.child('orders').push(data, response => response); 
    // }

    /**
     * HANDLE THE RADIO BUTTON SELECTIONS
     */
    handleRadioChange = (e, { name, value }) => {
        console.log("hx1 >>>>: handleRadioChange clicked");
        //log("hx12 e.target.name:"+e.target.name);
        console.log("hx13 value:" + value);
        console.log("hx14 name:" + name);

        //let pageColorCost = value === 'black' ? (this.state.totalNumpages * 300) : (this.state.totalNumpages * 500);
        let pageColorCost = value === 'black' ? 300 : 500;

        this.setState({
            blackWhiteColor: value,
            pageColorCost: pageColorCost
        });

        console.log("hx15 >> pageColorCost:" + pageColorCost);

        let newTotal = this.state.totalNumpages * ((pageColorCost * this.state.paperSizeMultiplier) * this.state.printOrPhotoCopyMultiplier) + this.state.stapleCost + this.state.bindingCharge;;
        this.setState({ totalPrice: newTotal });
        console.log("ntt newTotal:" + newTotal);

        //UPDATE OBJECT
        this.updateOrderObject();

    }

    handleLooseStapledRadioChange = (e, { name, value }) => {
        log("stx1 >>>>: handleLooseStapledRadioChange clicked");
        log("stx12 e.target.name:" + e.target.name);
        console.log("stx13 value:" + value);
        console.log("stx14 name:" + name);

        // const stapleCost = this.state.looseStapled === 'loose' ? (this.state.numCopies * 0) : (this.state.numCopies * 50);
        let stapleCost = value === 'loose' ? 0 : (this.state.numCopies * 50);

        this.setState({
            looseStapled: value,
            stapleCost: stapleCost
        });

        console.log("hx55 >> stapleCost:" + stapleCost);

        let newTotal = this.state.totalNumpages * ((this.state.pageColorCost * this.state.paperSizeMultiplier) * this.state.printOrPhotoCopyMultiplier) + stapleCost + this.state.bindingCharge;;
        this.setState({ totalPrice: newTotal });
        console.log("ntt newTotal:" + newTotal);
    }


    handleBindingChange = (e, { name, value }) => {
        console.log("hx73 value:" + value);
        console.log("hx74 name:" + name);

        let bindingCharge = 0;

        if (value === 'comb') {
            console.log("hx74 binding is comb");
            bindingCharge = this.state.numCopies * 1000

        } else if (value === 'wire') {
            console.log("hx75 binding is wire");
            bindingCharge = this.state.numCopies * 2000

        } else if (value === 'booklet') {
            console.log("hx76 binding is booklet");
            bindingCharge = this.state.numCopies * 3000
        }

        //  paperSizeCost =  pageColorCost * paperSizeCost;

        this.setState({
            binding: value,
            bindingCharge: bindingCharge
        });

        console.log("hx75 >> bindingCharge:" + bindingCharge);

        let newTotal = this.state.totalNumpages * ((this.state.pageColorCost * this.state.paperSizeMultiplier) * this.state.printOrPhotoCopyMultiplier) + this.state.stapleCost + bindingCharge;
        this.setState({ totalPrice: newTotal });
        console.log("ntt newTotal:" + newTotal);
    }

    handlePhotoCopyRadioChange = (e, { name, value }) => {
        //log("hx1 >>>>: handleChange clicked");
        //log("hx12 e.target.name:"+e.target.name);
        console.log("hx43 value:" + value);
        console.log("hx44 name:" + name);

        // const printPhotoCopyCost = (this.state.printPhotocopy === 'print' ? 1 : .77);
        let printOrPhotoCopyMultiplier = value === 'print' ? 1 : .77;

        this.setState({
            printPhotocopy: value,
            printOrPhotoCopyMultiplier: printOrPhotoCopyMultiplier
        });

        console.log("hx45 >> printOrPhotoCopyMultiplier:" + printOrPhotoCopyMultiplier);

        let newTotal = this.state.totalNumpages * ((this.state.pageColorCost * this.state.paperSizeMultiplier) * printOrPhotoCopyMultiplier) + this.state.stapleCost + this.state.bindingCharge;;
        this.setState({ totalPrice: newTotal });
        console.log("ntt newTotal:" + newTotal);

    }

    handlePaperSizeChange = (e, { name, value }) => {
        console.log("hx63 value:" + value);
        console.log("hx64 name:" + name);

        // const stapleCost = this.state.looseStapled === 'loose' ? (this.state.numCopies * 0) : (this.state.numCopies * 50);
        let paperSizeMultiplier = 1;

        if (value === 'A4') {
            console.log("hx64 paper is a4");
            paperSizeMultiplier = 1;

        } else if (value === 'A3') {
            console.log("hx64 paper is a3");
            paperSizeMultiplier = 2;

        } else if (value === 'A5') {
            console.log("hx64 paper is a5");
            paperSizeMultiplier = .5;
        }

        //  paperSizeCost =  pageColorCost * paperSizeCost;

        this.setState({
            paperSize: value,
            paperSizeMultiplier: paperSizeMultiplier
        });

        console.log("hx65 >> paperSizeMultiplier:" + paperSizeMultiplier);

        let newTotal = this.state.totalNumpages * ((this.state.pageColorCost * paperSizeMultiplier) * this.state.printOrPhotoCopyMultiplier) + this.state.stapleCost + this.state.bindingCharge;
        this.setState({ totalPrice: newTotal });
        console.log("ntt newTotal:" + newTotal);
    }

    //handlePhotoCopyRadioChange = (e, { value }) => this.setState({ printPhotocopy: value });
    // handleLooseStapledRadioChange = (e, { value }) => this.setState({ looseStapled: value });
    // handlePaperSizeChange = (e, { value }) => this.setState({ paperSize: value });
    handleSingleDoubleSidedChange = (e, { value }) => this.setState({ singleDoubleSided: value });
    //  handleBindingChange = (e, { value }) => this.setState({ binding: value });

    /**
     * HANDLE THE FILE UPLOADING..
     */
    handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
    handleUploadSuccess = (fileName) => this.setState({ fileName: fileName, isUploading: false, progress: 100 });
    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        this.setState({ isUploading: false });
        console.error(error);
    }

    testHandleInputFromComponent(e) {
        //console.log("tx1 input from component:"+target.value);
        console.log("tx33 e.target.type:" + e.target.type);
        console.log("tx32 e.target.name:" + e.target.name);
        console.log("tx34 e.target.value:" + e.target.value);
    }

    formValidationFunction = () => {
        console.log("fvx1 ++++++++ formValidationFunction");
        console.log("fvx12 this.state.email:" + this.state.email);
        console.log("fvx12 this.state.phone:" + this.state.phone);
        console.log("fvx13 emailValid:" + this.state.emailValid);
        console.log("fvx14 phoneValid:" + this.state.phoneValid);

        let fieldValidationErrors = this.state.formErrors;
        let tempformHasErrors = this.state.formHasErrors;

        if (this.state.email === undefined) {
            fieldValidationErrors.email = ' is invalid';
            tempformHasErrors = true;
        }

        if (this.state.phone === undefined) {
            fieldValidationErrors.phone = ' is invalid';
            tempformHasErrors = true;
        } else {
            tempformHasErrors = false;
        }

        this.setState({
            formErrors: fieldValidationErrors,
            formHasErrors: tempformHasErrors
        })


    }

    render() {

        const paperSizeRadioGroup = (
            <Form.Group inline>
                <Form.Field>
                    Paper Size: <b>{this.state.paperSize}</b>
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='A4'
                        name='paperSizeRadioGroup'
                        value='A4'
                        checked={this.state.paperSize === 'A4'}
                        onChange={this.handlePaperSizeChange}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='A3'
                        name='paperSizeRadioGroup'
                        value='A3'
                        checked={this.state.paperSize === 'A3'}
                        onChange={this.handlePaperSizeChange}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='A5'
                        name='paperSizeRadioGroup'
                        value='A5'
                        checked={this.state.paperSize === 'A5'}
                        onChange={this.handlePaperSizeChange}
                    />
                </Form.Field>
            </Form.Group>
        )

        const singleDoubleSidedRadioGroup = (
            <Form.Group inline>
                <Form.Field>
                    Single / Double Sided: <b>{this.state.singleDoubleSided}</b>
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='Single'
                        name='singleDoubleSidedRadioGroup'
                        value='single'
                        checked={this.state.singleDoubleSided === 'single'}
                        onChange={this.handleSingleDoubleSidedChange}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='Double'
                        name='singleDoubleSidedRadioGroup'
                        value='double'
                        checked={this.state.singleDoubleSided === 'double'}
                        onChange={this.handleSingleDoubleSidedChange}
                    />
                </Form.Field>
            </Form.Group>
        )

        const bindingRadioGroup = (
            <Form.Group inline>
                <Form.Field>
                    Binding: <b>{this.state.binding}</b>
                </Form.Field>
                {/* //COMB, LOOSE, WIRE, BOOKLET */}
                <Form.Field>
                    <Radio
                        label='None'
                        name='bindingRadioGroup'
                        value='none'
                        checked={this.state.binding === 'none'}
                        onChange={this.handleBindingChange}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='Loose'
                        name='bindingRadioGroup'
                        value='loose'
                        checked={this.state.binding === 'loose'}
                        onChange={this.handleBindingChange}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='Comb'
                        name='bindingRadioGroup'
                        value='comb'
                        checked={this.state.binding === 'comb'}
                        onChange={this.handleBindingChange}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='Wire'
                        name='bindingRadioGroup'
                        value='wire'
                        checked={this.state.binding === 'wire'}
                        onChange={this.handleBindingChange}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='Booklet'
                        name='bindingRadioGroup'
                        value='booklet'
                        checked={this.state.binding === 'booklet'}
                        onChange={this.handleBindingChange}
                    />
                </Form.Field>
            </Form.Group>
        )



        const deliveryUi = (
            <h3>{this.state.deliverCharge}</h3>
        )

        const totalNumpages = this.state.numPages * this.state.numCopies;

        // let totalNumpagesTEMP = this.state.numPages * this.state.numCopies;
        //console.log("totalNumpagesTEMP:"+totalNumpagesTEMP);

        //log("px1 totalNumpages:"+totalNumpages);

        const blackWhiteCost = totalNumpages * 300;
        //console.log("px12 blackWhiteCost:"+blackWhiteCost);

        const colorCost = totalNumpages * 500;
        //console.log("px13 colorCost:"+colorCost);

        const stapleCost = this.state.looseStapled === 'loose' ? (this.state.numCopies * 0) : (this.state.numCopies * 50);
        //console.log("px14 stapleCost:"+stapleCost);

        const printPhotoCopyCost = (this.state.printPhotocopy === 'print' ? 1 : .77);

        //const totalPriceConst = blackWhiteCost + colorCost;
        const pageColorCost = (this.state.blackWhiteColor === 'black' ? blackWhiteCost : colorCost);
        //log("px15 pageColorCost:"+pageColorCost);

        const a3Adder = this.state.paperSize === 'A3' ? pageColorCost * 1 : 0;
        //console.log("px16 a3Adder:"+a3Adder);

        const a5Deduction = this.state.paperSize === 'A5' ? pageColorCost * .5 : 0;
        //log("px17 a5Deduction:"+a5Deduction);

        const combBinding = this.state.binding === 'comb' ? this.state.numCopies * 1000 : 0;
        //console.log("px18 combBinding:"+combBinding);

        const wireBinding = this.state.binding === 'wire' ? this.state.numCopies * 2000 : 0;
        //console.log("px19 wireBinding:"+wireBinding);

        const bookletBinding = this.state.binding === 'booklet' ? this.state.numCopies * 3000 : 0;
        //console.log("px20 bookletBinding:"+bookletBinding);

        const bindingTotal = combBinding + wireBinding + bookletBinding;

        const printPhotoCopyTotal = pageColorCost * printPhotoCopyCost;

        const totalPriceConst = (printPhotoCopyTotal + stapleCost + a3Adder + bindingTotal + this.state.deliverCharge) - a5Deduction;
        // console.log("fx2 formValid:"+this.state.formHasErrors);

        // const priceTotalUi = (
        //     // <h2>Total: {this.state.totalPrice}</h2>
        // )

        return (
            <div>


                {/* <Link to={'/newOrder/confirmOrder'}>View Details</Link>  */}
                <BrowserRouter>
                    <Switch>
                        {/* <Route exact path='/newOrder' component ={entireFormUi} />  */}
                        {/* <Route exact path='/' component={MainMenu} /> */}

                        <Route exact path="/newOrder" render={() => (<OrderForm.MainFormObject
                            handleSubmit={this.handleSubmit}
                            handleChange={this.handleTextInputChange}
                            totalNumpages={this.state.totalNumpages}

                            //TEXT INPUT DEFAULT VALUE
                            emailValue={this.state.email}
                            phoneValue={this.state.phone}
                            numPagesValue={this.state.numPages}
                            numCopiesValue={this.state.numCopies}
                            locationValue={this.state.location}
                            // RADIO BUTTON FUNCTIONS
                            blackWhiteColorChangeHandler={this.handleRadioChange}
                            handleLooseStapledRadioChange={this.handleLooseStapledRadioChange}
                            handleBindingChange={this.handleBindingChange}
                            //RADION BUTTON VALUES
                            checkValue={this.state.blackWhiteColor}
                            looseStapled={this.state.looseStapled}
                            binding={this.state.binding}
                            //final price
                            total={this.state.totalPrice}
                            //FORM VALIDATION
                            formValidationFunction={this.formValidationFunction}
                            formErrors={this.state.formErrors}
                            formHasErrors={true}
                            allFieldsValid={this.state.allFieldsValid}
                            firstLoaded={this.state.firstLoaded}
                        />)} />

                        <Route path="/newOrder/confirmOrder" render={() => (<ConfirmOrder
                            totalPrice={this.state.totalPrice}
                            email={this.state.email}
                            phone={this.state.phone}
                            numPages={this.state.numPages}
                            numCopies={this.state.numCopies}
                            totalNumpages={this.state.totalNumpages}
                            blackWhiteColor={this.state.blackWhiteColor}
                            printPhotocopy={this.state.printPhotocopy}
                            looseStapled={this.state.looseStapled}
                            paperSize={this.state.paperSize}
                            singleDoubleSided={this.state.singleDoubleSided}
                            binding={this.state.binding}
                            fileName={this.state.fileName}
                            location={this.state.location}
                        />)} />

                        {/* THANK YOU SCREEN */}
                        {/* <Route path="/newOrder/thankYou" component={OrderForm.ThankYou} /> */}
                    </Switch>
                </BrowserRouter>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/orderProcess/NewOrderForm.js